import { FC } from 'react';
import { Layout } from 'components/Layout/Layout';
import { SendFeedback } from '../SendFeedback/SendFeedback';

interface IResultsProps {
  summary: string;
  sentToEmailCallback: () => void;
  sessionKey: string;
}

export const Results: FC<IResultsProps> = ({
  summary,
  sentToEmailCallback,
  sessionKey
}) => {
  return (
    <Layout>
      <SendFeedback
        summary={summary}
        sentToEmailCallback={sentToEmailCallback}
        sessionKey={sessionKey}
      />
    </Layout>
  );
};
